import React from 'react';

import {ESize} from '@edna/components';

export type TEditorVariableOption = {
  id: string | number;
  value: string;
  label: string;
};

export type TEditorValue = string;

export type TEditorHandler = (value: TEditorValue) => void;

export enum EEditorMetricsEvent {
  VARIABLE_SELECT = 'VARIABLE_SELECT',
  VARIABLE_CREATE = 'VARIABLE_CREATE',
  VARIABLE_CREATED = 'VARIABLE_CREATED',
  VARIABLE_CONVERT_TO_TEXT = 'VARIABLE_CONVERT_TO_TEXT',
  VARIABLE_FILL_TEXT = 'VARIABLE_FILL_TEXT',
}

export enum EEditorInsertType {
  REGEX = 'REGEX',
  VARIABLE = 'VARIABLE',
  EMPTY_VARIABLE = 'EMPTY_VARIABLE',
}

export const REGEX_LIMIT = 10;

export type TEditorInsertType = keyof typeof EEditorInsertType;
export enum EEditorRegExpType {
  STATIC = 'STATIC',
  LIMITED = 'LIMITED',
}

export type TLimitedRegexp = {
  type: EEditorRegExpType.LIMITED;
  value: string;
  create: (value: string | number) => string;
  match: (value: string) => string;
  matchLimit: (value: string) => number;
};

export type TEditorRegexp = TLimitedRegexp | {type: EEditorRegExpType.STATIC; value: string};

export type TSelectedVariable = {
  type: EEditorInsertType.VARIABLE;
  id?: TEditorVariableOption['id'];
  value?: TEditorVariableOption['value'];
};
export type TSelectedRegexp = {type: EEditorInsertType.REGEX; value: TEditorRegexp; n?: number};
export type TEntity =
  | TSelectedVariable
  | TSelectedRegexp
  | {type: EEditorInsertType.EMPTY_VARIABLE; value?: string};

type TEditorWithSelectorSize = ESize.S | ESize.XS;

export type TProps = {
  name: string;
  isInvalid?: boolean;
  value?: TEditorValue | null;
  startMatchChar?: string | string[];
  segmentsCount?: number | string | null;
  onChange?: TEditorHandler;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  type?: TEditorInsertType;
  disabled?: boolean;
  readOnly?: boolean;
  variableOptions?: TEditorVariableOption[];
  allowedRegexps?: TEditorRegexp[];
  regexps?: {value: string; type: EEditorRegExpType}[];
  rows?: number;
  isPostfix?: boolean;
  isEditableRegex?: boolean;
  isFixedMenu?: boolean;
  selector?: string;
  id?: string;
  hasFullWidth?: boolean;
  isValidateEntities?: boolean;
  hasDropdowns?: boolean;
  matchRegexp?: RegExp;
  size?: TEditorWithSelectorSize;
  isDynamicLineHeight?: boolean;
  onMetricsEvent?: (event: EEditorMetricsEvent) => void;
};

export type THandlerInsertParams =
  | {value: TEditorRegexp; isString?: undefined}
  | {value?: string; isString?: boolean};
